export type WalletType = 'safe' | 'smartWallet' | 'eoa'

export function getWalletType(isSafe: boolean, isContract: boolean): WalletType {
  if (isSafe) return 'safe'
  if (isContract) return 'smartWallet'
  return 'eoa'
}
